import { render, staticRenderFns } from "./CustomSearchSelfAssessment.vue?vue&type=template&id=1af3ece6&"
import script from "./CustomSearchSelfAssessment.vue?vue&type=script&lang=js&"
export * from "./CustomSearchSelfAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports